import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from './auth.service';
import { Store, select } from '@ngrx/store';
import { IState } from '../store/root.reducer';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  alreadyConfigured: boolean;
  user: User;
  subscriptions: Subscription[] = [];
  constructor(
    private store: Store<IState>,
  ) { }

  initialize() {
    this.resetVariables();
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.currentUser))
      .subscribe(currentUser => {
        if (currentUser && currentUser.contactId !== 0) {
          this.user = currentUser;
        }
      }));
  }

  resetVariables() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }

    this.user = <User>{};
    this.alreadyConfigured = false;
  }
}
